import React, { useState } from "react";
import SlugMessage from "../DoctorSlug/slugMessage";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { USER_ROLE, USER_TYPE } from "../../Util/constants";
import { OnlinePendingLogs } from "../OnlinePendingLogs";

export default function DoctorActivities(props) {
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);

  const [showShareLink, setShowShareLink] = useState(false);
  const [showPendingAppointments, setShowPendingAppointments] = useState(false);

  function handleShareLinkClick() {
    setShowShareLink(true);
  }

  function handleCloseShareLinkDrawer() {
    setShowShareLink(false);
  }

  function toggleDrawer() {
    setShowShareLink(!showShareLink);
  }

  // Actions ===>

  const handlePendingAppointmentLogs = () => {
    setShowPendingAppointments(true);
  };

  const handleClosePendingAppointmentsDrawer = () => {
    setShowPendingAppointments(false);
  };

  // <===

  return (
    <div className="mt-5">
      <h5>Activities</h5>
      <ul className="list-group border-0">
        {doctorRole !== USER_ROLE.DOCTOR_ADMIN &&
          userType !== USER_TYPE.STAFF && (
            <button
              className="list-group-item list-group-item-action pl-2 pr-2 icon_btn"
              onClick={handlePendingAppointmentLogs}
              style={{
                display: "flex",
                border: "0px",
                borderBottom: "1px solid #E6E6E6",
              }}
            >
              <div className="left_icon" style={{ flex: "1" }}>
                <i className="fa fa-calendar"></i>
                &nbsp;&nbsp;&nbsp;Online Appointment Logs
              </div>
              <div className="right_icon">
                <img
                  src={process.env.PUBLIC_URL + "/images/right_angle_arrow.svg"}
                  alt=""
                />
              </div>
            </button>
          )}
        <button
          className="list-group-item list-group-item-action border-0 pl-2 pr-2 icon_btn"
          onClick={handleShareLinkClick}
          style={{ display: "flex" }}
          disabled={doctorRole === USER_ROLE.RESOURCE_CONSULTANT}
        >
          <div className="left_icon" style={{ flex: "1" }}>
            <i className="fa fa-share"></i>
            &nbsp;&nbsp;&nbsp;Share Link
          </div>
          <div className="right_icon">
            <img
              src={process.env.PUBLIC_URL + "/images/right_angle_arrow.svg"}
              alt=""
            />
          </div>
        </button>
      </ul>

      <SlugMessage
        show={showShareLink}
        onClose={handleCloseShareLinkDrawer}
        toggleDrawer={toggleDrawer}
        name={props.doctorFullName}
        slug={props.slugUrl}
        isDoctorId={false}
        closeSlugModal={handleCloseShareLinkDrawer}
      />
      {showPendingAppointments && (
        <OnlinePendingLogs
          openPopup={showPendingAppointments}
          closeDrawerCallback={handleClosePendingAppointmentsDrawer}
        />
      )}
    </div>
  );
}
